import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';

const DelineationStatusForm = ({ 
  masterid, 
  onSubmit, 
  onCancel,
  isSubmitting = false,
  verifiedEmail = ''
}) => {
  const [formData, setFormData] = useState({
    email: verifiedEmail,
    delineation_feedback_comment: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field) => (event) => {
    setFormData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    if (!formData.delineation_feedback_comment) {
      newErrors.delineation_feedback_comment = 'Please describe the problem with the delineation';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validateForm()) {
      const submissionData = {
        masterid: masterid,
        email: formData.email,
        delineation_feedback_comment: formData.delineation_feedback_comment,
        delineation_feedback_date: new Date().toISOString()
      };
      console.log('Delineation Feedback Submission:', submissionData);
      onSubmit(submissionData);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h6" color="primary">
        Delineation Feedback
      </Typography>

      {/* Auto-populated fields display */}
      <Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Master ID:</strong> {masterid || 'N/A'}
        </Typography>
      </Box>

      {/* Email field */}
      <TextField
        label="Email"
        type="email"
        required
        fullWidth
        value={formData.email}
        onChange={handleChange('email')}
        error={!!errors.email}
        helperText={verifiedEmail ? 'Verified email address' : errors.email}
        placeholder="your.email@example.com"
        disabled={!!verifiedEmail}
        InputProps={{
          readOnly: !!verifiedEmail
        }}
        sx={verifiedEmail ? { '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)' } } : {}}
      />

      {/* Comment field */}
      <TextField
        label="Please describe the problem with the delineation"
        required
        fullWidth
        multiline
        rows={4}
        value={formData.delineation_feedback_comment}
        onChange={handleChange('delineation_feedback_comment')}
        error={!!errors.delineation_feedback_comment}
        helperText={errors.delineation_feedback_comment}
        placeholder="Describe what is incorrect about the delineation..."
      />

      {/* Action buttons */}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
        <Button variant="outlined" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button 
          variant="contained" 
          onClick={handleSubmit}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
        </Button>
      </Box>
    </Box>
  );
};

export default DelineationStatusForm;
